import * as React from 'react';

interface Props {
  className?: string;
}

export const CardHeading: React.FC<Props> = ({ children, className = '' }) => {
  return (
    <h3 className={`text-xs uppercase font-semibold ${className}`}>
      {children}
    </h3>
  );
};
